import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { notificationController } from "components/common/notificationController";
import { loadState } from "library/helpers/sessionStorage";
import { ADD_UPDATE_USER_REQUEST, FETCH_USERS_REQUEST } from "./actionTypes";
import {
  fetchUsersSuccess,
  fetchUsersFailure,
  fetchUsersRequest,
  addUpdateUserSuccess,
  addUpdateUserFailure,
} from "./actions";
import { User } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchUsersSaga(action: ReturnType<typeof fetchUsersRequest>) {
  try {
    const response: User[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount = response.length > 0 ? response[0].totalCount : 0;
    yield put(fetchUsersSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchUsersFailure(errorMessage));

    if (errorMessage && error?.response?.status !== 401) {
      notificationController.error({
        message: "Error",
        description: `Error fetching user list: ${errorMessage}`,
      });
    }
  }
}

function* addUpdateUserSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdateUserSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateUserFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* usersSaga() {
  yield takeLatest(FETCH_USERS_REQUEST, fetchUsersSaga);
  yield takeLatest(ADD_UPDATE_USER_REQUEST, addUpdateUserSaga);
}
